import React, { createContext, useState, useContext, useEffect } from 'react';
import api from '../services/api';
import notificationManager from '../utils/notificationManager';

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadStoredData = () => {
      const token = localStorage.getItem('@SenhasApp:token');
      const userData = localStorage.getItem('@SenhasApp:user');

      if (token && userData) {
        try {
          const parsedUser = JSON.parse(userData);
          
          // console.log('AuthContext - Dados do usuário carregados do localStorage:', {
          //   id: parsedUser?.id,
          //   nome: parsedUser?.nome,
          //   cargo: parsedUser?.cargo,
          //   email: parsedUser?.email
          // });
          
          // Garantir que o cargo exista e esteja no formato correto
          if (parsedUser && !parsedUser.cargo) {
            console.warn('AuthContext - Usuário sem cargo definido:', parsedUser);
            parsedUser.cargo = 'Admin';  // Valor padrão para usuários sem cargo
            localStorage.setItem('@SenhasApp:user', JSON.stringify(parsedUser));
          }
          
          api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
          setUser(parsedUser);
        } catch (error) {
          console.error('AuthContext - Erro ao processar dados do localStorage:', error);
          localStorage.removeItem('@SenhasApp:token');
          localStorage.removeItem('@SenhasApp:user');
        }
      }

      setLoading(false);
    };
    
    loadStoredData();
  }, []);

  const signIn = async (email, senha) => {
    try {
      console.log('AuthContext - Iniciando tentativa de login com:', { email });
      const response = await api.post('/auth/login', { email, senha });
      console.log('AuthContext - Resposta do servidor:', response.data);
      
      const { token, user } = response.data;

      // Garantir que o usuário tenha um cargo definido
      if (!user.cargo) {
        console.log('AuthContext - Usuário sem cargo, definindo como Admin por padrão');
        user.cargo = 'Admin';
      }
      
      console.log('AuthContext - Dados do usuário após autenticação:', {
        id: user?.id,
        nome: user?.nome,
        cargo: user?.cargo,
        cargoTipo: typeof user?.cargo,
        email: user?.email
      });

      localStorage.setItem('@SenhasApp:token', token);
      localStorage.setItem('@SenhasApp:user', JSON.stringify(user));

      // Definir timestamp de login para controle de notificações de sessão
      localStorage.setItem('loginTimestamp', Date.now().toString());

      api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      setUser(user);
      console.log('AuthContext - Login concluído com sucesso, usuário definido');

      return true;
    } catch (error) {
      console.error('AuthContext - Erro durante o login:', error.response?.data || error.message);
      throw error;
    }
  };

  const signOut = () => {
    console.log('AuthContext - Realizando logout');
    
    // Limpar notificações de sessão antes de fazer logout
    notificationManager.clearSessionOnLogout();
    
    localStorage.removeItem('@SenhasApp:token');
    localStorage.removeItem('@SenhasApp:user');
    setUser(null);
  };

  const updateUser = (userData) => {
    try {
      const updatedUser = { ...user, ...userData };
      
      console.log('AuthContext - Atualizando dados do usuário:', {
        antes: {
          id: user?.id,
          cargo: user?.cargo,
          email: user?.email
        },
        depois: {
          id: updatedUser?.id,
          cargo: updatedUser?.cargo,
          email: updatedUser?.email
        }
      });
      
      localStorage.setItem('@SenhasApp:user', JSON.stringify(updatedUser));
      
      setUser(updatedUser);
      
      return true;
    } catch (error) {
      console.error('AuthContext - Erro ao atualizar dados do usuário:', error);
      return false;
    }
  };

  return (
    <AuthContext.Provider
      value={{
        signed: !!user,
        user,
        loading,
        signIn,
        signOut,
        updateUser,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export default AuthContext; 